import {Route, Routes} from "react-router-dom";
import {PermissionLevel} from "../../app/api/model/user";
import RequireAuth from "../../components/RequireAuth";
import React from "react";
import SettingsDetailpage from "./Defaults";

export default function Settings() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.VIEW_ONLY}>
            <Routes>
                <Route index element={<SettingsDetailpage />} />
            </Routes>
        </RequireAuth>
    );
}
